import { UILabeledIcon } from "../Base/UILabeledIcon";
import { RewardType } from "../../../enums";
import { NUtils } from "../../../Utils/NUtils";
import { GameManager } from "../../../Game/GameManager";

export class MissionReward extends UILabeledIcon {
    Init(reward) {
        super.Init();
        this.reward = reward;
        this.iconSize = 1.1;
    }

    UpdateUI() {
        switch (this.reward.type) {
            case RewardType.MaxCreature:
                this.label = "";
                this.icon = "box";
                break;

            case RewardType.MoneySoftBySoftSpeed:
                this.label = NUtils.FormatMoney(this.reward.value * GameManager.gameController.MoneySoftSpeed);
                this.icon = "ico-gold";
                break;

            case RewardType.MoneyHard:
                this.label = NUtils.FormatMoney(this.reward.value);
                this.icon = "ico-diamond";
                break;

            default:
                this.label = "";
                this.icon = "";
                break;
        }
    }
}
